








import { Vue, Component } from 'vue-property-decorator';
import * as config from './config';
import { getRules } from '@/api/api';
import { appShare, wxShareInfo } from '@/common/ts/common';

@Component({
  components: {},
})
export default class Home extends Vue {
  option = config.OPTHINES;
  Rules = '';
  async created() {
    const res = await getRules(this.option.voteName);
    this.Rules = res.data;
    // 分享
    appShare({
      title: '《名师•名著•创新写作》',
      url: window.location.href,
      subtitle: '《名师•名著•创新写作》',
      classId: -1,
      id: -1,
      image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });
    wxShareInfo({
      title: '《名师•名著•创新写作》',
      subtitle: '《名师•名著•创新写作》',
      image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
}
